import React from 'react'
import PropTypes from 'prop-types'

import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Table, { TableBody, TableCell, TableRow } from 'material-ui/Table'
import Divider from 'material-ui/Divider'
import PercentageGraph from './PercentageGraph'
import ItemToolbar from './ItemToolbar'
import {chartColors, chartSizes, framework as appTheme } from '../etc/theme'
import Enum from 'swift-enum'

import {createSelector} from 'reselect'
import {
  acttasksSelector, 
  acttaskByStatusSelector, 
  collectionNameIsSelector,
  collectionNameHaveNot,
  lastFinishDateSelector,
  statusDateSelector,
  totalCostSelector,
  furthestAheadSelector,
  furthestBehindSelector

} from '../selectors/dataset'


import {maxBy} from 'lodash'
import * as f from '../etc/formatters'

// PropTypes
let _categoryShape = PropTypes.shape({
  total: PropTypes.number
})

let _chartShape = PropTypes.shape({
  notstarted_onschedule: _categoryShape,
  notstarted_behindschedule: _categoryShape,
  started_onschedule: _categoryShape,
  started_behindschedule: _categoryShape,
  complete: _categoryShape
})

let healthPercentageSelector = createSelector(
  acttasksSelector,
  acttaskByStatusSelector,
  (all_acttasks, by_status) => (by_status.complete.all.length + by_status.started_onschedule.all.length + by_status.notstarted_onschedule.all.length ) / all_acttasks.length
)

let formattedPercentageSelector = createSelector(
  healthPercentageSelector,
  percentage => `${Math.round(percentage * 100)/100}%`
)

// SHZ todo use this somewhere
let healthStringSelector = createSelector( 
  healthPercentageSelector,
  percentage => (
    percentage < 50  ? "Bad" :
    percentage < 75  ? "Not Good" :
    percentage < 90  ? "OK" :
    percentage < 100 ? "Good" :
    "Excellent"
  )
)

export let taglineSelector = createSelector(
  acttasksSelector,
  acttaskByStatusSelector,
  collectionNameIsSelector,
  collectionNameHaveNot,
  formattedPercentageSelector,
  (all_tasks, by_status, name_is, name_have_not, percentage) => {
    if (by_status.complete.all.length === all_tasks.length)
      return `${name_is} complete`
    else if (by_status.notstarted_onschedule.all.length === all_tasks.length)
      return `${name_have_not} started`
    else 
      return `${name_is} on schedule ${percentage}`
  }
)

let formattedTotalCostSelector = createSelector(
  totalCostSelector,
  total_cost => f.currency(total_cost)
)

let highestCostSelector = createSelector(
  acttasksSelector,
  acttasks => (maxBy(acttasks, acttask => acttask.total_cost))
)

export let detailedDescSelector = createSelector(
  statusDateSelector,
  lastFinishDateSelector,
  formattedPercentageSelector,
  taglineSelector,
  formattedTotalCostSelector,
  collectionNameIsSelector,
  highestCostSelector,
  furthestAheadSelector,
  furthestBehindSelector,
  (
    status_date, 
    last_finish_date,
     percentage, tagline, 
     total_cost, 
     name_is, 
     highest_cost,
     furthest_ahead,
     furthest_behind
    ) => (
    <Table>
    <TableBody>
      <TableRow>
        <TableCell>{tagline}</TableCell>
        <TableCell></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Estimated delivery date</TableCell>
        <TableCell>{f.dateFormatter(last_finish_date)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Days remaining to completion</TableCell>
        <TableCell>{f.daysFromNow(last_finish_date)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Dateline Date</TableCell>
        <TableCell>{f.dateFormatter(status_date)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>{name_is}</TableCell>
        <TableCell>{percentage} complete</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Total Cost</TableCell>
        <TableCell>{total_cost}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Highest cost task</TableCell>
        <TableCell>{highest_cost ? highest_cost.name : '- None found -'}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Task furthest behind</TableCell>
        <TableCell>{furthest_ahead ? furthest_ahead.name : '- None found -'}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Task furthest ahead</TableCell>
        <TableCell>{furthest_behind ? furthest_behind.name  : '- None found -'}</TableCell>
      </TableRow>
    </TableBody>
  </Table>
  )
)

class Filter extends Enum {}
Filter.case({none: ''})
Filter.freeze()

const defaultFilter = Filter.none
export {Filter, defaultFilter}

 

export let MainChart = ({dataset, currentFilter, onSetFilter, radius, width, height, ...rest}) => (
  <PercentageGraph 
    colors={chartColors.health} 
    value={healthPercentageSelector(dataset)} 
    radius={radius}
    {...rest}
   />
)  

let _Homepage = ({classes, dataset, filter, onSetFilter, currentFilter, ...rest}) => (
  <div className={classes.root} {...rest}>
    <MainChart 
      dataset={dataset} 
      onSetFilter={onSetFilter}
      currentFilter={currentFilter}
      radius={chartSizes.radius.large}
      className={classes.mainChart}
    />
    <Divider light/>
    {detailedDescSelector(dataset)}
  </div>
)
let styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 0,
    paddingBottom: 16,
    overflowX: 'auto',
  }),
  mainChart: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  legend : {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: 'auto',
    marginRight: 'auto'
  }
})

export let Homepage = withStyles(styles)(_Homepage)


// TaskHealth.propTypes = {
//   title: PropTypes.string.isRequired,
//   data: PropTypes.shape({ 
//     tasks: PropTypes.shape({
//       status: _chartShape
//     })
//   }).isRequired,
//   compact: PropTypes.bool.isRequired,
//   onMore: PropTypes.func.isRequired,
//   onClose: PropTypes.func.isRequired,
//   classes: PropTypes.object.isRequired
// }





// WEBPACK FOOTER //
// ./src/components/TaskHealth.js